import React from 'react';

import { cn } from '@/utils/styles.utils';

import styles from './SafeHtml.module.css';

interface Props {
  content: string;
  className?: string;
}
// All content should be from secure sources BE, not need to sanitize to decrease bundle size
export const SafeHtml = (props: Props) => {
  const { content, className } = props;

  return (
    <div
      className={cn(styles.html, className)}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
